export interface IAmoCRMLineUpdate {
  id?: string
  line: string
  description: string
  pipeline: string
  responsible_user: number
  smart_call: boolean
  start_time: string
  end_time: string
  incoming_call: string
  udpc: boolean
  find_unsorted: boolean
}

export const AmoCRMLineUpdateInitValues = {
  id: '',
  line: '',
  description: '',
  pipeline: 'Main',
  responsible_user: 0,
  smart_call: false,
  start_time: '09:00',
  end_time: '18:00',
  incoming_call: 'Unsorted',
  udpc: false,
  find_unsorted: false,
}

export interface IAmoCRMLineNew {
  line_newline: string
  description_newline: string
  pipeline_newline: string
  responsible_user_newline: number
  smart_call_newline: boolean
  start_time_newline: string
  end_time_newline: string
  incoming_call_newline: string
  udpc_newline: boolean
  find_unsorted_newline: boolean
}
